module.exports = __webpack_public_path__ + "static/media/pat1.6753eec0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/example/maps/pat1.jpg
// module id = 378
// module chunks = 0